import {CLEAR_MASS_GROUP, SET_MASS_GROUP} from "../actions/AssignmentActions"

const massGroupReducer = (state ={elutionCurve: {runCount: 0, structureElutionList:[]}}, action) => {

    switch (action.type) {

        case SET_MASS_GROUP:
            return {
                ...state,
                elutionCurve: action.elutionCurve
            };
        case CLEAR_MASS_GROUP:
            return {
                ...state,
                elutionCurve: {runCount: 0, structureElutionList:[]}
            };
        default:
            return state;
    }
};

export default massGroupReducer